import L from 'leaflet';
import Pin from '../../../Assets/Images/Components/Book/Map/kadroMapMarker.png';
import PinShadow from '../../../Assets/Images/Components/Book/Map/kadroMapMarkerShadow.png';
import PinCircleShadow from '../../../Assets/Images/Components/Book/Map/circle.png';
import Studio from '../../../Assets/Images/Components/Book/Map/studio-logo.png';
import StudioOut from '../../../Assets/Images/Components/Book/Map/studio-logo-out-of-range.png';
import Park from '../../../Assets/Images/Components/Book/Map/park-location.png';
import ParkCost from '../../../Assets/Images/Components/Book/Map/park-location-cost.png';

export const PinIcon = L.icon({
  iconUrl: Pin,
  iconSize: [38, 42],
  iconAnchor: [19, 42],
  popupAnchor: [0, -21],
  className: 'leaflet-icon',
  shadowUrl: PinCircleShadow,
  shadowSize: [24, 10],
  shadowAnchor: [12, 7],
});
export const PinIconActive = L.icon({
  iconUrl: Pin,
  iconSize: [38, 42],
  iconAnchor: [19, 48],
  popupAnchor: [0, -21],
  className: 'leaflet-icon',
  shadowUrl: PinCircleShadow,
  shadowSize: [20, 6],
  shadowAnchor: [10, 4],
});
export const StudioIcon = L.icon({
  iconUrl: Studio,
  iconSize: [38, 42],
  iconAnchor: [19, 42],
  popupAnchor: [0, -21],
  className: 'leaflet-icon'
});
export const StudioOutIcon = L.icon({
  iconUrl: StudioOut,
  iconSize: [38, 42],
  iconAnchor: [19, 42],
  popupAnchor: [0, -21],
  className: 'leaflet-icon'
});
export const ParkIcon = L.icon({
  iconUrl: Park,
  iconSize: [38, 42],
  iconAnchor: [19, 42],
  popupAnchor: [0, -21],
  className: 'leaflet-icon',
});
export const ParkCostIcon = L.icon({
  iconUrl: ParkCost,
  iconSize: [38, 42],
  iconAnchor: [19, 42],
  popupAnchor: [0, -21],
  className: 'leaflet-icon',
});
